import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { DateInputField, FormButton, SelectInputField } from '../../../../components/common'
import { Modal } from '../../../../components/Modals'
import { useSocial } from '../../../../hooks/useSocial'
import { SocialAttributes } from '../../../../types/history.type'
import { showToast } from '../../../../utils/toast'
import { socialSchema } from '../../../../validation/pDirectory.schema'

type Props = {
  onClose: () => void
  id?: string
  defaultData?: SocialAttributes
}

const EditSocial = ({ onClose, defaultData, id }: Props) => {
  const { patientId } = useParams()
  const methods = useForm({ defaultValues: defaultData, resolver: yupResolver(socialSchema) })
  const { updateSocial } = useSocial({ patientId: patientId || '' })

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data
        },
        type: 'social_history'
      }
    }
    try {
      await updateSocial({ data: payload, id: id || '' })
      onClose()
    } catch (error: any) {
      showToast(error?.response?.data?.errors![0]?.detail || 'an error occurred')
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title="Edit Social">
        <Form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box gap={'24px'} overflow={'auto'} pad={'medium'}>
            {/* <Box>
              <FormInputField label="Name" name="social_name" />
            </Box> */}
            <Box>
              <SelectInputField label="Status" name="status" options={['Active', 'improved', 'stopped']} />
            </Box>
            <Box>
              <DateInputField label="Date" name="date" />
            </Box>
          </Box>
          <FormButton isLoading={methods.formState.isSubmitting} onClose={onClose} submit="save" />
        </Form>
      </Modal>
    </FormProvider>
  )
}

export default EditSocial
